var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
// Entities
import { Thread } from 'packages/email/entities/Thread';
// Services
import { MessageRepository } from 'packages/email/MessageRepository';
// Components
import EmailMessage from './EmailMessage.vue';
import { container } from 'tsyringe';
import { Dispatcher } from 'packages/core/events/Dispatcher';
import { EmailRead } from 'packages/core/events/EmailRead';
import UiSecondaryButton from 'ui/v1/controls/UiSecondaryButton.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import { Getter, namespace } from 'vuex-class';
import { Job } from 'packages/v3/jobs/Job';
import moment from 'moment';
import debounce from 'common/decorators/debounce';
import isNil from 'common/support/isNil';
var jobsModule = namespace('jobs');
var talentEmail = namespace('talentCard/talentEmailState');
var UpdatableElement = /** @class */ (function () {
    function UpdatableElement(data, element) {
        this.data = data;
        this.element = element;
        this.updating = false;
    }
    UpdatableElement.prototype.startUpdating = function () {
        this.updating = true;
    };
    UpdatableElement.prototype.stopUpdating = function () {
        this.updating = false;
    };
    Object.defineProperty(UpdatableElement.prototype, "isUpdating", {
        get: function () {
            return this.updating;
        },
        enumerable: false,
        configurable: true
    });
    return UpdatableElement;
}());
var MessageList = /** @class */ (function (_super) {
    __extends(MessageList, _super);
    function MessageList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.readTime = 1000;
        _this.messageRepo = container.resolve(MessageRepository);
        _this.dispatcher = container.resolve(Dispatcher);
        _this.messageElementMap = [];
        return _this;
    }
    Object.defineProperty(MessageList.prototype, "messages", {
        get: function () {
            return this.selectedThread ? this.selectedThread.messages : [];
        },
        enumerable: false,
        configurable: true
    });
    MessageList.prototype.markMessagesReadInView = function () {
        var _this = this;
        if (!this.$refs.messageList) {
            return;
        }
        this.messageElementMap.forEach(function (item) {
            if (!item.element || item.isUpdating || item.data.readAt) {
                return;
            }
            var rect = item.element.getBoundingClientRect();
            var isInViewport = (rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth));
            if (!isInViewport) {
                return;
            }
            item.startUpdating();
            setTimeout(function () {
                _this.messageRepo.markMessageRead(item.data.id).then(function (updatedMessage) {
                    _this.dispatcher.dispatch(new EmailRead());
                    var now = moment().format();
                    updatedMessage.readAt = now;
                    item.data.readAt = now;
                    item.stopUpdating();
                    _this.$emit('messageRead', updatedMessage);
                });
            }, _this.readTime);
        });
    };
    MessageList.prototype.loadThread = function (threadId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!threadId) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.findThread({
                                talentId: this.talentId,
                                threadId: this.threadId,
                                jobId: this.candidateIsolationEnabledOrNil ? this.job.id : null,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.$nextTick(function () {
                            if (!isNil(_this.emailMessages) && _this.emailMessages.length !== 0) {
                                _this.messageElementMap = _this.emailMessages
                                    .map(function (emailMessage) { return new UpdatableElement(emailMessage.message, emailMessage.$el.querySelector('#header')); });
                            }
                            _this.markMessagesReadInView();
                        });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var _a, _b;
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], MessageList.prototype, "talentId", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], MessageList.prototype, "threadId", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Array)
    ], MessageList.prototype, "emailMessages", void 0);
    __decorate([
        Getter,
        __metadata("design:type", Boolean)
    ], MessageList.prototype, "candidateIsolationEnabledOrNil", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_a = typeof Job !== "undefined" && Job) === "function" ? _a : Object)
    ], MessageList.prototype, "job", void 0);
    __decorate([
        talentEmail.State,
        __metadata("design:type", typeof (_b = typeof Thread !== "undefined" && Thread) === "function" ? _b : Object)
    ], MessageList.prototype, "selectedThread", void 0);
    __decorate([
        talentEmail.State,
        __metadata("design:type", Boolean)
    ], MessageList.prototype, "loading", void 0);
    __decorate([
        talentEmail.Action,
        __metadata("design:type", Function)
    ], MessageList.prototype, "findThread", void 0);
    __decorate([
        debounce(200),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MessageList.prototype, "markMessagesReadInView", null);
    __decorate([
        Watch('selectedThread.id'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], MessageList.prototype, "loadThread", null);
    MessageList = __decorate([
        Component({
            components: {
                UiSecondaryButton: UiSecondaryButton,
                EmailMessage: EmailMessage,
                Icon: Icon,
            },
        })
    ], MessageList);
    return MessageList;
}(Vue));
export default MessageList;
